// SZÖVEG-KERESÉS szabad szövegre — ÉKEZET- és kis-nagybetű-érzéketlen részszó-illesztés.
//
// MIÉRT KÖZÖS ÉS MIÉRT ÍGY: a magyar felhasználó a keresőbe gyakran ékezet nélkül gépel („panzio", „acs",
// „kartyas"), az adatban viszont ékezetes alak van („Panzió", „Ács", „kártyás"). Egy sima
// `toLowerCase().includes()` erre nem illeszt — egy több száz elemű listán ez a különbség a használhatóság.
// Az `Intl.Collator` nem ad „contains"-t, ezért NFD-normalizálással szedjük le a diakritikusokat.
//
// MIÉRT A `@atlas/shared`-BEN: KÉT runtime illeszt szabad szövegre. (1) A web a már betöltött opció-listákon
// (combobox/multiselect), (2) a BFF a GLOBÁLIS KERESŐBEN (`SearchService`) — a tipizált [T] busz-táblák nem
// tudnak szerver-oldali `q`-szűrőt, ezért a szűrés BFF-oldalon, memóriában történik. Két külön másolat
// elcsúszna, és a ⌘K máshogy illesztene, mint ugyanannak az adatnak a lista-szűrője (mérve: a ⌘K a
// „kartyas"-ra nem adott találatot arra, amit a lista-szűrő megtalált).
/** Ékezet nélküli, kisbetűs alak (NFD → diakritikusok eldobva). */
export function normalizeForSearch(text) {
    return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}
/** Illeszkedik-e a `text` a `query` részszóra (ékezet- és kis-nagybetű-érzéketlenül)? Üres query → igen. */
export function matchesSearch(text, query) {
    const needle = normalizeForSearch(query.trim());
    return needle === '' ? true : normalizeForSearch(text).includes(needle);
}
//# sourceMappingURL=search-text.js.map